import DIApi from './_diApi';

class AccountTransferAPI extends DIApi {
  constructor() {
    super();
  }
  controllerName = 'AccountTransfers';
}

export default new AccountTransferAPI();
